import { Button } from '@mui/material';
import { FC } from 'react';
import FormSubmitButton from './FormSubmitButton';

interface IFormButtonsProps {
  allowSubmitPristine?: boolean;
  disabled?: boolean;
  disabledCancel?: boolean;
  onCancel: () => void;
  submitButtonText?: string;
}

const FormButtons: FC<IFormButtonsProps> = ({ allowSubmitPristine, disabled, disabledCancel, onCancel, submitButtonText = 'Save & Next' }) => (
  <div className='flex items-center gap-16 pb-24'>
    <div className='w-1/2'>
      <Button onClick={onCancel} sx={{ width: '100%' }} variant='outlined' disabled={disabledCancel}>
        Cancel
      </Button>
    </div>
    <div className='w-1/2'>
      <FormSubmitButton allowSubmitPristine={allowSubmitPristine} disabled={disabled} sx={{ width: '100%' }}>
        {submitButtonText}
      </FormSubmitButton>
    </div>
  </div>
);

export default FormButtons;
